<template>
    <div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
      <HeadNav selectedLanguage="en" page="instasave"  
          :gotodownload="gotodownload"
          :apk="apk"/>
      <div id="page" class="site container hfeed">
        <div id="content" class="site-content">
          <div id="primary" class="content-area">
            <main id="maincontent" class="site-main">
              <!-- Hero Section -->
              <HeroSection 
                :title="heroTitle"
                :subtitle="heroSubtitle"
                :input-placeholder="inputPlaceholder"
                :active-tab="activeTab"
                @tab-change="switchTab"
                @download-content="downloadContent"
                @go-to-download="goToDownload"
                @join-telegram="joinTelegramChannel"
              />
              <div class="home-wrapper">
               
    
                <!-- How to Download Section -->
                <HowToSection
                  :title="'Instagram’dan video ve fotoğraf nasıl indirilir - InstaSave'"
                  :steps="howToSteps"
                />
    
                <!-- Why Use InstaSave Section -->
                <section class="why-use-section">
                  <h2 class="section-title">Instagram (IG) indirme için neden Instasave?</h2>
                  <ul class="benefits-list">
                    <li>
                      <h3>Sınırsız indirme</h3>
                      <p>Kurulum yok, giriş yok. Her gün istediğiniz kadar video ve fotoğrafı hiçbir kısıtlama olmadan indirebilirsiniz.</p>
                    </li>
                    <li>
                      <h3>%100 anonim</h3>
                      <p>Hem mobilde hem bilgisayarda çalışır. Herhangi bir kişisel veri paylaşmadan Instagram’da gezinip içerik indirebilirsiniz.</p>
                    </li>
                    <li>
                      <h3>Hızlı ve tamamen ücretsiz</h3>
                      <p>Gönderiler, Reels, karusel fotoğraflar ve bazı herkese açık Hikâye linklerini destekler. Hizmetimiz tamamen otomatik, hızlı, güvenli ve %100 ücretsizdir.</p>
                    </li>
                  </ul>
                </section>
    
                <!-- App Recommendation Section -->
                <AppRecommendationSection 
                  :title="appRecommendationTitle"
                  :description="appRecommendationDescription"
                  :button-text="appRecommendationButtonText"
                  :image-src="appRecommendationImageSrc"
                  :image-alt="appRecommendationImageAlt"
                  @go-to-download="goToDownload"
                />
    
                <!-- Why Choose Online First Section -->
                <section class="choice-section">
                  <div class="choice-card">
                    <h3>Neden önce online, sonra InstaSave uygulaması?</h3>
                    <ul>
                      <li><strong>Online:</strong> ara sıra indirmeler için en hızlı yol; kurulum yok, her cihazda çalışır.</li>
                      <li><strong>Uygulama:</strong> sık kullananlar için ideal — toplu indirme, arka planda çalışma, çevrimdışı galeri ve daha akıllı dosya adlandırma.</li>
                      <li>Deneyiminizi paylaşmak, yeni yöntemler öğrenmek veya Instagram içerik indirme sorunlarını konuşmak isterseniz, tartışma için <a href="https://freegbdownload.com/" class="jump-url" target="_blank">GB WhatsApp</a> grubuna katılabilirsiniz.</li>
                    </ul>
              </div>
                </section>
    
                <!-- Features Sections -->
                <FeaturesGrid :features="features" />
    
                <!-- FAQ Section -->
                <section class="faq-section">
                  <h2 class="section-title">FAQ & Troubleshooting</h2>
                  <div class="faq-container">
                    <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
                      <div class="faq-question" @click="toggleFaq(index)">
                        <div style="font-size: 1.2rem; font-weight: 600;">{{ faq.question }}</div>
                        <span class="faq-toggle">{{ expandedFaqs.includes(index) ? '−' : '+' }}</span>
                      </div>
                      <div v-if="expandedFaqs.includes(index)" class="faq-answer">
                        <p v-html="faq.answer"></p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </main> 
          </div>
        </div>
      </div>
    
    </div>
    </template>
    
    <script>
    import '@/css/base.scss';
    import '@/css/index.scss';
    import HeadNav from '@/components/HeadNav.vue';
    import Footer from '@/components/Footer.vue';
    import HeroSection from '@/components/HeroSection.vue';
    import HowToSection from '@/components/HowToSection.vue';
    import FeaturesGrid from '@/components/FeaturesGrid.vue';
    import AppRecommendationSection from '@/components/AppRecommendationSection.vue';
    
    export default {
      name: 'Home',
      components: {
        HeadNav,
        Footer,
        HeroSection,
        HowToSection,
        FeaturesGrid,
        AppRecommendationSection
      },
      head() {
        return {
          title: 'InstaSave – Instagram video ve fotoğraf indirme',
          meta: [
            {
              hid: 'description',
              name: 'description',
              content: 'InstaSave sayesinde Instagram videolarını ve fotoğraflarını kolayca online indirebilirsiniz. Linki yapıştırın, indir’e tıklayın ve favori IG içeriklerinizi yüksek kalitede kaydedin.'
            },
            {
              hid: 'keywords',
              name: 'keywords',
              content: 'Instagram video indirme, instasave, Instagram fotoğraf indirme'
            }
          ]
        }
      },
      data() {
        return {
          pageName: 'home',
          instagramLink: '',
          expandedFaqs: [],
          activeTab: '',
          heroTitle: 'InstaSave – Instagram indirici',
          heroSubtitle: 'Sadece Instagram linkini yapıştırın ve indirme butonuna tıklayın',
          inputPlaceholder: 'Linki buraya yapıştırın',
          appRecommendationTitle: 'InstaSave: Android için Instagram indirme (uygulama önerisi)',
          appRecommendationDescription: 'Sık sık içerik kaydediyorsanız, uygulama kullanmak daha pratiktir. InstaSave Android için tasarlandı ve hız, toplu indirme ve düzenli galeri deneyimine odaklanır.',
          appRecommendationButtonText: 'InstaSave’i ücretsiz indir',
          appRecommendationImageSrc: require('@/assets/home/home-1.webp'),
          appRecommendationImageAlt: 'InstaSave App',
          faqs: [
            {
              question: "İndirme yapmak için giriş yapmam gerekiyor mu?",
              answer: "Online araçla çoğu herkese açık gönderi için hayır. Bazı Hikâyeler veya özel içerikler için zaten Instagram uygulamasında erişiminizin olması gerekir; görebildiğiniz bir linki paylaştığınızda Android uygulamamız yardımcı olabilir."
            },
            {
              question: "İndirdiğim videoda ses yok, neden?",
              answer: "Bazı parçalar lisanslı ses içerir ve üçüncü taraf araçlar bu sesleri ekleyemez. Mümkünse uygulamadaki \"orijinal ses\" benzeri bir seçenekle indirmeyi deneyin veya içerik sahibinden (izin alarak) farklı bir sürüm kaydedin."
            },
            {
              question: "Kaydettikten sonra video neden bulanık görünüyor?",
              answer: "Instagram medyayı sıkıştırır. İndirme sırasında sunulan en yüksek kaliteyi seçin. Android’de Instasave ayarlarından \"HD’yi tercih et\" seçeneğini etkinleştirin."
            },
            {
              question: "Gizli hesaplardan da indirme yapabilir miyim?",
              answer: "Sadece hesabı takip ediyor ve içeriği uygulamada görebiliyorsanız; ardından linki Instasave ile paylaşabilir veya kopyalayabilirsiniz. Asla gizlilik ayarlarını aşmaya çalışmayın."
            },
            {
              question: "Dosyalarım nereye kaydediliyor?",
              answer: "Masaüstü: tarayıcınızın Downloads (İndirilenler) klasörüne.<br>Android: Dahili depolama › Pictures/Movies › Instasave (ayarlar üzerinden değiştirilebilir).<br>iPhone (online araç): Files veya Photos uygulamasına (seçtiğiniz kayıt yöntemine göre)."
            },
            {
              question: "\"Geçersiz\" link hatası neden çıkıyor?",
              answer: "Tam URL’yi kopyaladığınızdan (fazladan boşluk olmadığından) emin olun. Instagram’ı tekrar açın, Paylaş › Linki kopyala adımlarını izleyin ve linki yeniden yapıştırın."
            },
            {
              question: "Bu uygulamayı kullanırsam hesabım banlanır mı?",
              answer: "Instagram şifrenizi asla istemiyoruz. Yine de Instagram kurallarına uymanız ve yalnızca izin verilen içerikleri indirmeniz önemlidir."
            },
            {
              question: "Zamanlayarak veya toplu indirme yapabilir miyim?",
              answer: "Evet — Android’de Instasave içine birden fazla link yapıştırabilir veya panodan otomatik yakalama özelliğini açarak dosyaları sıraya alabilirsiniz."
            },
            {
              question: "Karusel ve Öne Çıkanlar için de çalışıyor mu?",
              answer: "Evet. Online araçta tek tek öğe seçebilir, uygulamada ise \"Hepsini indir\" seçeneğiyle hepsini bir kerede kaydedebilirsiniz."
            },
            {
              question: "Bu hizmet ücretsiz mi?",
              answer: "Online indirici ve Android için Instasaver tamamen ücretsizdir."
            }
          ],
          howToSteps: [
            {
              title: "Adım 1: Instagram linkini kopyalayın",
              items: [
                "Instagram’ı açın (uygulama veya web).",
                "Bir gönderi, Reel, Hikâye öne çıkarılanı veya IGTV üzerinde üç nokta (veya Paylaş) simgesine dokunun.",
                "\"Linki kopyala\" seçeneğini seçin."
              ]
            },
            {
              title: "Adım 2: Linki yapıştırın",
              items: [
                "Buraya geri dönün ve linki indirme kutusuna yapıştırın."
              ]
            },
            {
              title: "Adım 3: Video/fotoğraf indirin",
              items: [
                "\"İndir\" butonuna tıklayın.",
                "Video veya Fotoğraf seçin (karusel ise dosyaları tek tek seçin).",
                "Cihazınıza kaydedin (mobil: Files/Fotolar, masaüstü: Downloads klasörü)."
              ]
            }
          ],
          features: [
            {
              title: "Instagram videosu indirin",
              description: "Online aracımızla Instagram videolarını tek tıkla kolayca indirebilirsiniz. Video linkini kopyalayın, kutuya yapıştırın ve MP4 formatında doğrudan cihazınıza kaydedin. Ek yazılım gerekmez; hem masaüstü hem mobilde çalışır.",
              imageSrc: require('@/assets/home/home-2.webp'),
              imageAlt: "Instagram video indirme"
            },
            {
              title: "Instagram fotoğrafları indirin",
              description: "İndiricimizi kullanarak Instagram fotoğraflarını yüksek çözünürlükte hızlıca kaydedin. İster tek bir fotoğraf, ister tam bir karusel gönderi olsun, linki yapıştırmanız yeterli; görseller anında kaydedilir. Hızlı, basit ve tamamen online.",
              imageSrc: require('@/assets/home/home-3.webp'),
              imageAlt: "Instagram fotoğraf indirme"
            },
            {
              title: "Instagram Hikâye Kaydedici",
              description: "Instagram Story Saver özelliğimiz, hikâyeler kaybolmadan önce onları kaydetmenizi sağlar. Hikâye linkini kopyalayın, araca yapıştırın ve doğrudan telefonunuza veya bilgisayarınıza indirin. Öne çıkanlar ve herkese açık hikâyeler için giriş yapmadan çalışır.",
              imageSrc: require('@/assets/home/home-4.webp'),
              imageAlt: "Instagram Hikâye kaydedici"
            },
            {
              title: "Instagram Reels indirme",
              description: "Reels videolarını çevrimdışı saklamak mı istiyorsunuz? Instagram Reels indirme özelliğimiz, herhangi bir Reels’i MP4 dosyası olarak kaydetmenize izin verir. Reels linkini araca yapıştırın ve yüksek kalitede indirerek dilediğiniz zaman, dilediğiniz yerde izleyin.",
              imageSrc: require('@/assets/home/home-5.webp'),
              imageAlt: "Instagram Reels indirme"
            },
            {
              title: "Instagram gönderi indirme",
              description: "Instagram gönderi indirme seçeneğimizle; fotoğraf, video veya karusel albümleri dahil olmak üzere tam gönderileri kaydedebilirsiniz. Gönderi linkini kopyalayıp buraya yapıştırın ve gönderideki tüm medyayı anında indirin.",
              imageSrc: require('@/assets/home/home-6.webp'),
              imageAlt: "Instagram gönderi indirme"
            },
            {
              title: "IGTV indirme",
              description: "IGTV indirme özelliğimiz, uzun Instagram videolarını kaydetmeyi kolaylaştırır. IGTV linkini kopyalayın, indiriciye yapıştırın ve videoyu çevrimdışı izlemek için MP4 formatında alın. Eğitim videoları, programlar ve röportajlar için idealdir.",
              imageSrc: require('@/assets/home/home-7.webp'),
              imageAlt: "IGTV indirme"
            }
          ]
        };
      },
      computed: {
        currentTabTitle() {
          const currentTab = this.navTabs.find(tab => tab.id === this.activeTab);
          return currentTab ? currentTab.title : 'Instagram Download';
        }
      },
      methods: {
        switchTab(tabId) {
          this.activeTab = tabId;
          console.log('Switching to tab:', tabId);
        },
        pasteFromClipboard() {
          if (navigator.clipboard && navigator.clipboard.readText) {
            navigator.clipboard.readText().then(text => {
              this.instagramLink = text;
            }).catch(err => {
              console.error('Failed to read clipboard contents: ', err);
            });
              } else {
            // Fallback for older browsers
            alert('Please paste the link manually');
          }
        },
        downloadContent() {
          // 直接下载APK文件，参考instagram-apk-download页面的实现
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Downloading APK:', apkUrl);
        },
        toggleFaq(index) {
          const expandedIndex = this.expandedFaqs.indexOf(index);
          if (expandedIndex > -1) {
            this.expandedFaqs.splice(expandedIndex, 1);
              } else {
            this.expandedFaqs.push(index);
              }
        },
        gotodownload() {
          // 直接下载APK文件
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Download APK:', apkUrl);
        },
        goToDownload() {
          // 跳转到下载页面
          this.$router.push('/instagram-apk-downlad/');
        },
        joinTelegramChannel() {
          // 跳转到Telegram频道
          window.open('https://t.me/+M75kow80SlQ1MjZl', '_blank');
        },
      },
    };
    </script>
    
    <style scoped>
    
    .home-wrapper {
      max-width: 1000px;
      margin: 0 auto;
      margin-top: 1rem;
    }
    
    /* Hero Section - 重新设计 */
    .hero-section {
      background: linear-gradient(80deg, #D009FF 0%, #3b82f6 100%);
      color: white;
      padding: 60px 20px 80px;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      overflow: hidden;
    }
    
    .hero-content {
      max-width: 1000px;
      margin: 0 auto;
    }
    
    /* Logo - 移除，因为图片中没有显示logo */
    .hero-logo {
      display: none;
    }
    
    /* Navigation Tabs */
    .nav-tabs {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-bottom: 50px;
      flex-wrap: wrap;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      padding: 8px;
      border-radius: 30px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 50px;
    }
    
    .nav-tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 16px;
      background: transparent;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      flex: 1;
      justify-content: center;
    }
    
    .nav-tab:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }
    
    .nav-tab.active {
      background: rgba(255, 255, 255, 0.25);
      color: white;
      font-weight: 600;
    }
    
    .tab-icon {
      font-size: 14px;
    }
    
    .tab-text {
      font-weight: inherit;
    }
    
    /* Main Title */
    .hero-title {
      font-size: 2.8rem;
      font-weight: 600;
      color: white;
      text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
      letter-spacing: -0.5px;
    }
    
    /* Input Section */
    .paste-link-container {
      max-width: 600px;
      margin: 0 auto;
    }
    
    .coming-soon-note {
      text-align: center;
      margin-top: 15px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      font-style: italic;
      opacity: 0.9;
    }
    
    .action-buttons {
      display: flex;
      gap: 15px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      flex-wrap: wrap;
    }
    
    .download-app-btn {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .download-app-btn:hover {
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
    
    .telegram-btn {
      background: transparent;
      color: white;
      border: 2px solid rgba(255, 255, 255, 0.3);
      padding: 0px 22px;
      height: min-content;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
    }
    
    .telegram-btn:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.6);
      transform: translateY(-2px);
    }
    
    .btn-icon {
      width: 34px;
      height: 34px;
      object-fit: contain;
    }
    
    .input-group {
      display: flex;
      gap: 0;
      background: white;
      padding: 4px;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
      align-items: center;
      border: 1px solid rgba(0,0,0,0.05);
    }
    
    .link-input {
      flex: 1;
      border: none;
      padding: 16px 20px;
      font-size: 15px;
      border-radius: 8px;
      outline: none;
      background: transparent;
      color: #333;
    }
    
    .link-input::placeholder {
      color: #9ca3af;
      font-weight: 400;
    }
    
    .paste-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 12px 16px;
      background: #e5e7eb;
      color: #6b7280;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 13px;
      font-weight: 500;
      margin-right: 4px;
    }
    
    .paste-btn:hover {
      background: #d1d5db;
      color: #374151;
    }
    
    .paste-icon {
      font-size: 14px;
    }
    
    .download-btn {
      background: #ef4444;
      color: white;
      border: none;
      padding: 16px 24px;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }
    
    .download-btn:hover {
      background: #dc2626;
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    }
    
    /* Section Styles - 简洁的标题设计 */
    .section-title {
      text-align: center;
      margin-bottom: 40px;
      color: #333;
    }
    
    
    /* Why Use Section - 浅灰背景 */
    .why-use-section {
      padding: 40px 20px;
      background: #f8f9fa;
    }
    
    .benefits-list {
      max-width: 1000px;
      margin: 0 auto;
      list-style: none;
      padding: 0;
      /* display: grid; */
      /* grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); */
      gap: 40px;
    }
    
    .benefits-list li {
      margin-bottom: 20px;
      background: white;
      padding: 40px 30px;
      border-radius: 20px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.08);
      font-size: 16px;
      color: #555;
      text-align: left;
      position: relative;
      padding-left: 80px;
      transition: all 0.3s ease;
      border: 1px solid rgba(102, 126, 234, 0.1);
      list-style: none;
    }
    
    .benefits-list li:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0,0,0,0.12);
      border-color: rgba(102, 126, 234, 0.2);
    }
    
    .benefits-list li::before {
      content: '';
      position: absolute;
      top: 30px;
      left: 15px;
      width: 50px;
      height: 50px;
      border-radius: 15px;
      background: linear-gradient(135deg, #667eea, #764ba2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      font-weight: bold;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .benefits-list li:nth-child(1)::before {
      content: '∞';
      background: linear-gradient(135deg, #667eea, #764ba2);
    }
    
    .benefits-list li:nth-child(2)::before {
      content: '👤';
      background: linear-gradient(135deg, #f093fb, #f5576c);
    }
    
    .benefits-list li:nth-child(3)::before {
      content: '⚡';
      background: linear-gradient(135deg, #4facfe, #00f2fe);
    }
    
    .benefits-list li h3 {
      margin: 0 0 15px 0;
      font-size: 1.3rem;
      font-weight: 700;
      color: #2c3e50;
    }
    
    .benefits-list li p {
      margin: 0;
      line-height: 1.6;
      color: #666;
    }
    
    /* App Recommendation Section */
    
    /* Choice Section - 白色背景 */
    .choice-section {
      padding: 30px 20px;
      background: white;
    }
    
    .choice-card {
      max-width: 800px;
      margin: 0 auto 30px;
      background: #f8f9fa;
      padding: 30px;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    .choice-card h3 {
      font-size: 1.4rem;
      margin-bottom: 20px;
      color: #333;
      font-weight: 600;
    }
    
    .choice-card ul {
      list-style: none;
      padding: 0;
    }
    
    .choice-card li {
      padding: 12px 0;
      color: #666;
      font-size: 18px;
      border-bottom: 1px solid #e9ecef;
    }
    
    .choice-card li:last-child {
      border-bottom: none;
    }
    
    .choice-image {
      /* text-align: center; */
      width: 230px;
      height: 230px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .choice-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    
    /* FAQ Section - 现代化折叠设计 */
    .faq-section {
      padding: 20px 20px;
      background: white;
      margin-bottom: 20px;
    }
    
    .faq-container {
      max-width: 800px;
      margin: 0 auto;
    }
    
    .faq-item {
      background: white;
      margin-bottom: 20px;
      border-radius: 15px;
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
      overflow: hidden;
      transition: box-shadow 0.3s ease;
    }
    
    .faq-item:hover {
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    }
    
    .faq-question {
      padding: 25px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: background-color 0.3s ease;
    }
    
    .faq-question:hover {
      background: #f8f9fa;
    }
    
    .faq-question h3 {
      margin: 0;
      font-size: 1.2rem;
      color: #2c3e50;
      font-weight: 600;
    }
    
    .faq-toggle {
      font-size: 1.5rem;
      font-weight: bold;
      color: #667eea;
      transition: transform 0.3s ease;
    }
    
    .faq-item.expanded .faq-toggle {
      transform: rotate(45deg);
    }
    
    .faq-answer {
      padding: 0 25px 25px;
      color: #555;
      line-height: 1.6;
        font-size: 16px;
      }
      
    /* Responsive Design */
    @media (max-width: 768px) {
      .hero-section {
        padding: 40px 20px 60px;
      }
      
      .logo-sss {
        font-size: 2rem;
      }
      
      .logo-instagram {
        font-size: 1.5rem;
      }
      
      .nav-tabs {
        gap: 6px;
        margin-bottom: 40px;
        padding: 6px;
        border-radius: 25px;
      }
      
      .nav-tab {
        padding: 8px 12px;
        font-size: 11px;
      }
      
      .hero-title {
        font-size: 2rem;
        margin-bottom: 40px;
      }
      
      .input-group {
        flex-direction: column;
        gap: 8px;
        border-radius: 12px;
        padding: 12px;
      }
      
      .link-input, .paste-btn, .download-btn {
        border-radius: 8px;
        width: 100%;
      }
      
      .paste-btn {
        margin-right: 0;
        margin-bottom: 8px;
      }
      
      .section-title {
        font-size: 1.8rem;
      }
      
      
      .app-content {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .app-image {
        width: 200px;
        height: 200px;
      }
      
      
      .feature-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-card {
        padding: 25px;
      }
      
      .benefits-list {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .benefits-list li {
        padding: 30px 25px;
        padding-left: 70px;
      }
      
      .benefits-list li::before {
        width: 45px;
        height: 45px;
        top: 25px;
        left: 20px;
        font-size: 20px;
      }
      
      .faq-question {
        padding: 20px;
      }
      
      .faq-answer {
        padding: 0 20px 20px;
    }
    }
    </style>
    